import toast from "react-hot-toast";
import { useLoaderData } from "react-router-dom";
import "./Profile.css";
import { UpdateProfile } from "../../../auth/updateProfile/UpdateProfile";
import { CompleteProfile } from "../../../auth/completeProfile/CompleteProfile";
import { Box } from "@mui/material";
import { useUser } from "../../../../contexts/UserContext";

export const Profile = () => {
  const user = useLoaderData();
  const {userData: data, profileComplete, loadingUserData: loading, error, clearError} = useUser();

  // Show loading state while fetching user data
  if (loading) {
    return <Box 
      sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "50vh", maxHeight: "50vh" }}>
        Loading...
      </Box>;
  }

  if(!loading && error !== null) {
    error === "Invalid or expired access token."
        ? toast.error("Token expired, please re-login and try")
        : toast.error(error);

    clearError();
  }

  // If profile is incomplete, show CompleteProfile wizard
  // If profile is complete, show full UpdateProfile form (update mode)
  return profileComplete ? (
    <UpdateProfile type="update" data={data} token={user?.token} />
  ) : (
    <CompleteProfile />
  );
};
